import React from "react";
import AboutMe from "../sections/AboutMe";
import Skills from "../sections/Skills";
import Experience from "../sections/Experience";
import Contact from "../sections/Contact";

function Content() {
  return (
    <main>
      <AboutMe />
      <Skills />
      <Experience />
      <Contact />
    </main>
  );
}

export default Content;
